import React from "react";
import { Alert, Button, Icon, Modal, Spin } from "antd";
import { ModalProps } from "antd/lib/modal";
import style from "./index.module.scss";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import ResultMessage from "components/CourseComponents/ResultMessage";
import { errorMessage } from "service/service";
import {
    downloadQuestionErrExcel,
    ImportResultListItem,
    ImportState
} from "service/answerStore";

interface ResultModalProps extends ModalProps {
    data: ImportResultListItem[]; //考试id
    onCancel: () => void;
    loading: boolean; //数据加载状态
}

export default function ResultModal({
    data,
    onCancel,
    loading,
    ...resProps
}: ResultModalProps) {
    const download = async (fileName: string) => {
        try {
            await downloadQuestionErrExcel(fileName);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    const footer = <div className={style.footer}>-仅保留七日内的导入结果-</div>;

    return (
        <Modal
            width={610}
            title="导入结果"
            maskClosable={false}
            className={style.root}
            footer={data.length ? footer : null}
            onCancel={onCancel}
            {...resProps}>
            <Spin spinning={loading}>
                {!data.length && (
                    <CustomEmpty
                        description="尚未导入，无导入结果"
                        style={{ padding: "40px 40px 64px" }}
                    />
                )}
                {!!data.length && (
                    <>
                        <Alert
                            message="关闭 「导入结果」窗口、切换页面或退出系统，Excel 导入试卷任务仍在继续，若Excel 导入试卷失败，您可在当前窗口点击“下载”按钮下载导入结果查看导入失败原因。"
                            type="warning"
                            showIcon
                        />

                        <div className={style.list}>
                            {data.map((item, index) => (
                                <div className={style.item} key={index}>
                                    <div className={style.left}>
                                        <img
                                            src={require("./img/icon.png")}
                                            alt=""
                                        />
                                        导入时间 {item.createTime}
                                    </div>
                                    <div className={style.right}>
                                        {item.state === ImportState.success && (
                                            <div>
                                                <Icon type="check-circle" />
                                                导入成功
                                            </div>
                                        )}
                                        {item.state === ImportState.error && (
                                            <Button
                                                type="primary"
                                                onClick={() =>
                                                    download(item.fileName)
                                                }>
                                                下载
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </Spin>
        </Modal>
    );
}
